// extracted by mini-css-extract-plugin
export default {"licenseImage":"LicenseImage_licenseImage__W4b2Y","description":"LicenseImage_description__dc1HU"};